import { TIntakeStep } from '../config/steps';
import { ContactInfoStep } from './steps/ContactInfoStep';
import { LocationCheckStep } from './steps/LocationCheckStep';
import { MemberDetailsStep } from './steps/MemberDetailsStep';
import { PcpStatusStep } from './steps/PcpStatusStep';
import { PediatricsUpsellStep } from './steps/PediatricsUpsellStep';
import { QuoteEditStep } from './steps/QuoteEditStep';
import { QuoteMembersStep } from './steps/QuoteMembersStep';
import { QuoteStep } from './steps/QuoteStep';
import { ReasonsStep } from './steps/ReasonsStep';
import { SignupTypeStep } from './steps/SignupTypeStep';
import { UrgencyStep } from './steps/UrgencyStep';
import { WelcomeStep } from './steps/WelcomeStep';
import { ZipCodeStep } from './steps/ZipCodeStep';

type NativeStepRendererProps = {
  stepConfig: TIntakeStep;
};

export const IntakeStepSwitcher = ({ stepConfig }: NativeStepRendererProps) => {
  switch (stepConfig.id) {
    case 'welcome':
      return <WelcomeStep />;

    case 'signup-type':
      return <SignupTypeStep />;

    case 'zip-code':
      return <ZipCodeStep />;

    case 'location-check':
      return <LocationCheckStep />;

    case 'reasons':
      return <ReasonsStep />;

    case 'urgency':
      return <UrgencyStep />;

    case 'pcp-status':
      return <PcpStatusStep />;

    case 'contact-info':
      return <ContactInfoStep />;

    case 'member-details':
      return <MemberDetailsStep />;

    case 'pediatrics-upsell':
      return <PediatricsUpsellStep />;

    case 'quote':
      return <QuoteStep />;

    case 'quote-edit':
      return <QuoteEditStep />;

    case 'quote-members':
      return <QuoteMembersStep />;

    default:
      return (
        <div className='mx-auto w-full max-w-2xl px-4 py-8'>
          <p className='text-sh-gray-dark'>
            Unknown step type: {stepConfig.id}
          </p>
        </div>
      );
  }
};
